// src/components/common/LoadingSpinner.tsx
import React from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
                                                           size = 'md',
                                                           className = '',
                                                           text
                                                       }) => {
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12'
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className="flex flex-col items-center space-y-2">
                <div
                    className={`${sizeClasses[size]} animate-spin border-2 border-blue-600 border-t-transparent rounded-full`}
                />
                {text && (
                    <p className="text-sm text-gray-600">{text}</p>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner;
